import { connect } from "react-redux";

import _Screen from "./studio_screen.jsx";
import _ScreenHeader from "./studio_screen_header.jsx";
import _ScreenBody from "./studio_screen_body.jsx";
import _ScreenFooter from "./studio_screen_footer.jsx";

export const Screen = _Screen;
export const ScreenHeader = _ScreenHeader;
export const ScreenBody = _ScreenBody;
export const ScreenFooter = _ScreenFooter;

export const screenConnect = (component) => {
  const mapStateToProps = (state) =>
    state.screen ? { library: state.library, ...state.screen.state } : {};

  return connect(mapStateToProps)(component);
};
